import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jackpotFormat'
})
export class JackpotFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    if (isNaN(value)) {
      return value?.toString();
    }

    const roundedAmt = Math.round(value);
    return roundedAmt.toLocaleString('en-US');
  }
}
